import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {PARAM_STATE} from '@inspark/widget-common';
import {PieStatuses} from '../pie/pie.service';


@Component({
  selector: 'app-object-pie-tooltip',
  templateUrl: './pie-tooltip.component.html',
  styleUrls: ['./pie-tooltip.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectPieTooltipComponent  {

  @Input() count = 30;
  @Input() size = 40;
  @Input() title = 'Temp title';

  PARAM_STATE= PARAM_STATE;

  @Input() statuses: PieStatuses =
    {
      '-2': 20,
      '-1': 20,
      0: 4,
      1: 3,
      2: 4,
      3: 5
    }
  ;

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {

  }

/*
  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  ngOnChanges(changes) {
  }
*/

}




